import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { formatCurrency } from "helpers/utils";
import type { TypeStatusInscricao } from "interfaces/inscricoes";
import { EXTRATO_ACCENT } from "./extrato.theme";

type Totals = Partial<{
  [k in TypeStatusInscricao]: { qtd: number; total: number };
}>;

function StatMini({
  label,
  value,
  hint,
  accent,
}: {
  label: string;
  value: string;
  hint?: string;
  accent?: boolean;
}) {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid",
        borderColor: accent ? "rgba(249, 96, 48, 0.3)" : "grey.200",
        bgcolor: accent ? "rgba(249, 96, 48, 0.04)" : "background.paper",
        height: "100%",
      }}
    >
      <Typography variant="h4" fontWeight="bold" color={accent ? EXTRATO_ACCENT : "text.primary"}>
        {value}
      </Typography>
      {hint ? (
        <Typography variant="caption" color="text.secondary" display="block" mb={0.25}>
          {hint}
        </Typography>
      ) : null}
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

type Props = {
  totals: Totals;
  totalRegistros: number;
};

export default function ExtratoResumoCards({ totals, totalRegistros }: Props) {
  const pago = totals?.Pago;
  const pendente = totals?.Pendente;
  const cancelado = totals?.Cancelado;

  return (
    <Grid container spacing={2} mb={3}>
      <Grid item xs={6} sm={3}>
        <StatMini
          label="Inscrições no período"
          value={String(totalRegistros)}
          hint={`${pago?.qtd ?? 0} confirmadas`}
          accent
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatMini
          label="Confirmadas"
          value={formatCurrency(pago?.total ?? 0)}
          hint={`${pago?.qtd ?? 0} inscrição(ões)`}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatMini
          label="Pendentes"
          value={formatCurrency(pendente?.total ?? 0)}
          hint={`${pendente?.qtd ?? 0} inscrição(ões)`}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <StatMini
          label="Canceladas"
          value={formatCurrency(cancelado?.total ?? 0)}
          hint={`${cancelado?.qtd ?? 0} inscrição(ões)`}
        />
      </Grid>
    </Grid>
  );
}
